import { HStack } from '@chakra-ui/react';
import { Button, IconButton, TruncatableText } from 'Atoms';
import { Dispatch, SetStateAction } from 'react';
import { Typography } from 'Tokens';
import { ArrowNarrowLeftIcon } from 'Tokens/Icons/Direction';

export const ViewHistory = ({
  viewHistory,
  setViewHistory,
  setSelectedView,
}: {
  viewHistory: string[];
  setViewHistory: Dispatch<SetStateAction<string[]>>;
  setSelectedView: Dispatch<SetStateAction<string>>;
}) => {
  return (
    <HStack gap={'4px'} alignSelf={'start'}>
      <IconButton
        icon={<ArrowNarrowLeftIcon />}
        size="xs"
        variant="ghost"
        aria-label={'Back'}
        onClick={() => {
          if (viewHistory.length === 3) {
            setSelectedView('standardView');
          } else if (viewHistory.length === 2) {
            setSelectedView('generalView');
          }
          setViewHistory((prevHistory) => {
            return prevHistory.slice(0, prevHistory.length - 1);
          });
        }}
      />
      <HStack gap={'2px'}>
        {viewHistory.map((view, idx) => {
          return (
            <HStack gap={'2px'}>
              <Button
                size="xs"
                variant="ghost"
                p="1px 2px"
                justifyContent="flex-start"
                _hover={{ bg: !(idx === viewHistory.length - 1) ? 'bg.hover' : 'unset' }}
                cursor={idx === viewHistory.length - 1 ? 'auto' : 'pointer'}
                maxW="500px"
                onClick={() => {
                  if (idx !== viewHistory.length - 1) {
                    if (idx === 0) {
                      setViewHistory([viewHistory[0]]);
                      setSelectedView('generalView');
                    } else if (idx === 1) {
                      setViewHistory((prevHistory) => prevHistory.slice(0, prevHistory.length - 1));
                      setSelectedView('standardView');
                    }
                  }
                }}
              >
                <Typography
                  fontSize={'14px'}
                  color={idx === viewHistory.length - 1 ? 'text.hint' : 'text.default'}
                  textOverflow="ellipsis"
                  overflow={'hidden'}
                >
                  {view[0].toUpperCase() + view.slice(1)}
                </Typography>
              </Button>
              {idx !== viewHistory.length - 1 && (
                <Typography marginRight={'2px'} color={'text.hint'}>
                  /
                </Typography>
              )}
            </HStack>
          );
        })}
      </HStack>
    </HStack>
  );
};
